import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import NextLink from "next/link";
import type React from "react";
import { cn } from "~/lib/utils";
interface LogoProps extends React.HTMLAttributes<HTMLDivElement> {
  disabledLink?: boolean;
  innerRef?: React.Ref<HTMLImageElement>;
}
const Logo: React.FC<LogoProps> = t0 => {
  const $ = _c(13);
  let className;
  let innerRef;
  let other;
  let t1;
  if ($[0] !== t0) {
    ({
      disabledLink: t1,
      className,
      innerRef,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = innerRef;
    $[3] = other;
    $[4] = t1;
  } else {
    className = $[1];
    innerRef = $[2];
    other = $[3];
    t1 = $[4];
  }
  const disabledLink = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("min-w-10 min-h-10 cursor-pointer: hover:opacity-80", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== innerRef || $[8] !== other || $[9] !== t2) {
    t3 = <Image ref={innerRef} src="/logo/logo_single.svg" alt="KC-Fonden" width={40} height={40} className={t2} {...other} />;
    $[7] = innerRef;
    $[8] = other;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const logo = t3;
  if (disabledLink) {
    return logo;
  }
  let t4;
  if ($[11] !== logo) {
    t4 = <NextLink href="/">{logo}</NextLink>;
    $[11] = logo;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default Logo;